export const skuCard_master = {
    promoLineStyle: {
        color: '#f7a700',
        fontSize: '16px',
        'font-weight' : '700',
        lineHeight: '20px',
    },
    promoFootNoteStyle: {
        fontSize: '12px',
        fontStyle: 'italic',
        'font-weight': 'bold',
        marginTop: '5'
    }
}